import { createFileRoute } from "@tanstack/react-router";

import PromptTemplatePage from "../pages/PromptTemplate";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/prompt-template")({
  component: PromptTemplateRoute,
});

function PromptTemplateRoute() {
  return (
    <RequireAuth require="admin">
      <PromptTemplatePage />
    </RequireAuth>
  );
}
